import script from "./MoleculeTableSmallModal2.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTableSmallModal2.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTableSmallModal2.vue?vue&type=style&index=0&id=595b9e00&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595b9e00"]])

export default __exports__